import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import NinegridImg from "../../assets/images/ninegrid-logo.png";
// import TotvsImg from "../../assets/images/totvs-logo.png";
import TotvsBlackImg from '../../assets/images/logo-totvs-black.png';
import TotvsWhiteImg from '../../assets/images/logo-totvs-white.png';
import NinegridBlackImg from '../../assets/images/logo-ninegrid-black.png';
import NinegridWhiteImg from '../../assets/images/logo-ninegrid-white.png';
import { MainButton } from "../../components/MainButton";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import InputMask from "react-input-mask";
import { Loading } from "../../components/Loading";

import "./index.css";
import Swal from "sweetalert2";
import { useSeller } from "../../hooks/useSeller";
import { Input } from "../../components/Input/Input";
import { usePluginspace } from "../../hooks/usePluginspace";

export function SellerLogin() {
	const navigate = useNavigate();
	const params = useParams();
	const { getAppConfig } = useAppConfig();
	const { registerAccess } = usePluginspace();
	const [config, setConfig] = useState<ConfigType | void>();
	const [loading, setLoading] = useState(true);
	const [logged, setLogged] = useState(false);

	const [sellerIdentifier, setSellerIdentifier] = useState("");
	const [sellerEmail, setSellerEmail] = useState("");
	const [sellerPassword, setSellerPassword] = useState("");

	const [alarmIdentifier, setAlarmIdentifier] = useState(false);
	const [alarmLogin, setAlarmLogin] = useState(false);
	const [alarmPassword, setAlarmPassword] = useState(false);

	const [maskCpf, setMaskCpf] = useState("999.999.999-99");

	const { sellerLogin } = useSeller();

	useEffect(() => {
		registerAccess('seller')
		getConfig();
		localStorage.removeItem("seller-tk");
	}, [params]);

	async function getConfig() {
		setConfig(await getAppConfig());
		setLoading(false);
	}

	function toCategory() {
		navigate(`/${params.pluginspace_id}/category`);
	}

	async function loginSeller() {
		setLoading(true);
		const pluginspaceName = atob(params.pluginspace_id!)

		const loginResult = await sellerLogin(
			sellerEmail,
			sellerPassword,
			sellerIdentifier,
			pluginspaceName
		);
		setLoading(false);
		if (loginResult) {
			toCategory();
		} else {
			Swal.fire({
				icon: "error",
				title: "Erro - Dados Inválidos",
				text: "Seu email ou senha estão incorretos. Revise e tente novamente",
			});
		}
	}

	return (
		<div className="home">
			{loading ? (
				<div style={{width: '100%', height: 'calc(100vh)'}}>
					<Loading
						type="spinningBubbles"
						color="#FFF"
						width={64}
						height={64}
					/>
				</div>
			) : (
				<div
					className="content-home"
					style={config?.background ? {
						backgroundImage: `url(${config?.background})`,
						backgroundSize: 'cover',
					} : {}}
				>

					<div className="logo-home">
						{config?.img &&
							<img src={config.img} alt="Logo" />
						}
					</div>
					<div className="actions-home">
						{logged ? (
							<MainButton
								color={
									config?.webappcolor.fontbuttonhome
										? config.webappcolor.fontbuttonhome
										: "#636363"
								}
								backgroundColor={
									config?.webappcolor.backgroundbuttonhome
										? config.webappcolor
											.backgroundbuttonhome
										: "#EAEAEA"
								}
								text="Entrar"
								onClick={toCategory}
							/>
						) : (
							<div className="form-seller">
								<div className="title-form">
									<h2>Acesso do vendedor</h2>
								</div>
								<div className="inputs">
									<div>
										<InputMask
											mask={maskCpf}
											type="text"
											placeholder="CPF"
											value={sellerIdentifier}
											onChange={(event) =>
												setSellerIdentifier(
													event.target.value
												)
											}
											onBlur={() =>
												sellerIdentifier[1] === "_"
													? setAlarmIdentifier(true)
													: setAlarmIdentifier(false)
											}
										/>
										{alarmIdentifier && (
											<p className="alarm-text">
												Informe um CPF
											</p>
										)}
									</div>
									<div>
										<input
											placeholder="Login"
											type="email"
											value={sellerEmail}
											onChange={(event) =>
												setSellerEmail(
													event.target.value
												)
											}
											onBlur={() =>
												sellerEmail === ""
													? setAlarmLogin(true)
													: setAlarmLogin(false)
											}
										/>
										{alarmLogin && (
											<p className="alarm-text">
												Informe o login
											</p>
										)}
									</div>
									<div>
										{/* <input
											placeholder="Senha"
											type="password"
											value={sellerPassword}
											onChange={(event) =>
												setSellerPassword(
													event.target.value
												)
											}
											onBlur={() =>
												sellerPassword === ""
													? setAlarmPassword(true)
													: setAlarmPassword(false)
											}
										/> */}
										<Input
											inputAttr={{
												type: "password",
												name: "password",
												autoComplete: "off",
											}}
											label="Senha"
											placeholder="Senha"
											value={sellerPassword}
											change={setSellerPassword}
										/>
										{alarmPassword && (
											<p className="alarm-text">
												Informe a senha
											</p>
										)}
									</div>
								</div>
								<div className="footer">
									<MainButton
										color={
											config?.webappcolor.fontbutton
												? config.webappcolor.fontbutton
												: "#636363"
										}
										backgroundColor={
											config?.webappcolor.webappbutton
												? config.webappcolor
													.webappbutton
												: "#EAEAEA"
										}
										text="Continuar"
										onClick={loginSeller}
									/>
								</div>
							</div>
						)}
					</div>
					<div className="footer-home">
						{config?.content.useLogoTotvs &&
							<img src={config && config.content && config.content.colorLogo === 'white' ? TotvsWhiteImg : TotvsBlackImg} alt="TOTVS" className='totvs-img' />
						}
						{config?.content.useLogoTotvs &&
							<h2 style={{ color: config && config.content && config.content.colorLogo === 'white' ? 'white' : 'black' }}>by</h2>
						}
						<img src={config && config.content && config.content.colorLogo === 'white' ? NinegridWhiteImg : NinegridBlackImg} alt="Ninegrid by pluginbot" className='ninegrid-img' />
					</div>
				</div>
			)}
		</div>
	);
}
